var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightLandLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68921 8.85242L8.41171 2.56592L9.86146 2.95442L11.969 9.73067L15.9147 10.7882C16.0574 10.8264 16.1912 10.8923 16.3084 10.9823C16.4257 11.0722 16.524 11.1843 16.5979 11.3122C16.6718 11.4402 16.7198 11.5814 16.7391 11.7279C16.7584 11.8744 16.7487 12.0232 16.7105 12.1659C16.6722 12.3086 16.6063 12.4424 16.5164 12.5596C16.4265 12.6769 16.3143 12.7752 16.1864 12.8491C16.0585 12.923 15.9172 12.971 15.7707 12.9903C15.6243 13.0096 15.4754 12.9999 15.3327 12.9617L4.10371 9.95267L4.68571 7.77917L4.86721 7.82792L5.55271 10.3404L3.58246 9.81317C3.42101 9.76972 3.2787 9.67358 3.17815 9.54C3.0776 9.40643 3.02456 9.24308 3.02746 9.07592L3.09496 5.02367L4.18171 5.31467L4.86721 7.82792L8.68921 8.85242ZM3.99871 15.2499H15.9987V16.7499H3.99871V15.2499Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightLandLine);
export default __webpack_public_path__ + "static/media/flight-land-line.d3ec7a690e9d4e66cd4d945cc4295499.svg";
export { ForwardRef as ReactComponent };